import PropTypes from 'prop-types';
import React, {Component} from 'react';

//helpers
import {toggleClass} from 'utils/dom-utils';

//styled-components
import {FadingOverlay, InnerWrapper, OffsetParent} from './styles';

export default class FadingOverflowComponent extends Component {
  static defaultProps = {
    fadeColor: '#fff',
    isDisabled: false,
    isScrollable: true
  };

  static propTypes = {
    fadeColor: PropTypes.string,
    isDisabled: PropTypes.bool,
    isScrollable: PropTypes.bool
  };

  contentElement = null;
  overlayElement = null;

  componentDidMount() {
    this.update(false);
  }

  componentDidUpdate() {
    this.update(false);
  }

  render() {
    const {children, fadeColor, isScrollable, ...forwardedProps} = this.props;

    return (
      <OffsetParent {...forwardedProps}>
        <InnerWrapper
          ref={ref => {
            this.contentElement = ref;
          }}
          isScrollable={isScrollable}
          onScroll={this.handleScroll}
        >
          {children}
        </InnerWrapper>
        <FadingOverlay
          color={fadeColor}
          ref={ref => {
            this.overlayElement = ref;
          }}
          isScrollable={isScrollable}
        />
      </OffsetParent>
    );
  }

  handleScroll = () => {
    this.update(true);
  };

  update = shouldAnimate => {
    const {isDisabled} = this.props;
    const {clientHeight, scrollHeight, scrollTop} = this.contentElement;

    const hasReachedBottom = Math.abs(scrollTop - (scrollHeight - clientHeight)) < 2;
    const hasReachedTop = scrollTop === 0;

    toggleClass(this.overlayElement, 'has-reached-bottom', isDisabled || hasReachedBottom);
    toggleClass(this.overlayElement, 'has-reached-top', isDisabled || hasReachedTop);
    toggleClass(this.overlayElement, 'should-animate', shouldAnimate);
  };
}
